// Pathify
import Vue from 'vue'
import { dispatch, make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'
// import { IN_BROWSER } from '@/util/globals'
import store from '@/store'
import Pusher from 'pusher-js'
import Echo from 'laravel-echo'
import { VData } from 'vuetify/lib/components'
// import { format, parse } from "date-fns";

Vue.use(router)

// Data
const state = {
  logged_in: localStorage.getItem('cumuluslog@logged_in') || false,
  profile: JSON.parse(localStorage.getItem('cumuluslog@profile')) || null,
  organizations: JSON.parse(localStorage.getItem('cumuluslog@organizations')) || null,
  // pusher: null,
  echo: null,
  notifications: [],
  redirect: '/',
}

const mutations = {
  ...make.mutations(state),
  set_token (payload) {
    state.token = payload.token
    state.expires = payload.expires
    state.expiresDate = payload.expiresDate
  },
  login (user) {
    state.logged_in = true
    state.profile = {
      user_id: user.id,
      user_name: user.name,
      flight_stat: user.flight_stat,
      flight_stat_glider: user.flight_stat_glider,
      flight_stat_general: user.flight_stat_general,
      organization: user.organization,
      has_role: user.has_role,
      lang: user.language,
      can: user.can,
      // balance_stat: user.balance_stat,
      avatar: user.avatar,
      planes: user.planes,
      logbook_glider_on: user.logbook_glider_on,
      logbook_general_on: user.logbook_general_on,
      balance_stat: user.balance_stat,
      settings: user.settings,
      trainings: user.trainings,
      rent_permits: user.rent_permits,
      private_profile_id: user.private_profile_id,
      private_profile_status: user.private_profile_status,
      private_profile_created_at: user.private_profile_created_at,
    }
    console.log(user.settings.items_per_page)
    VData.options.props.itemsPerPage.default = () => parseInt(user.settings.items_per_page) ?? 10
    // actions.pusher_connect(user.id)
    actions.echo_connect(user.id)
    dispatch('app/localeChange', { lang: state.profile.lang })
    localStorage.setItem('cumuluslog@profile', JSON.stringify(state.profile))
    localStorage.setItem('cumuluslog@logged_in', true)
  },
  set_profile (profile) {
    state.profile.user_name = profile.name
    state.profile.has_role = profile.has_role
    state.profile.can = profile.can
    state.profile.organization = profile.organization
    // state.profile.balance_stat = profile.balance_stat
    state.profile.avatar = profile.avatar
    state.profile.planes = profile.planes
    state.profile.logbook_glider_on = profile.logbook_glider_on
    state.profile.logbook_general_on = profile.logbook_general_on
    state.profile.balance_stat = profile.balance_stat
    state.profile.settings = profile.settings
    state.profile.trainings = profile.trainings
    state.profile.rent_permits = profile.rent_permits
    state.profile.private_profile_id = profile.private_profile_id
    state.profile.private_profile_status = profile.private_profile_status
    state.profile.private_profile_created_at = profile.private_profile_created_at
    dispatch('datasource/clear')
    localStorage.setItem('cumuluslog@profile', JSON.stringify(state.profile))
  },
  set_organizations (organizations) {
    state.organizations = organizations
    localStorage.setItem('cumuluslog@organizations', JSON.stringify(state.organizations))
  },
  set_logout () {
    // actions.pusher_disconnect()
    actions.echo_disconnect()
    state.logged_in = false
    state.redirect = '/'
    state.profile = {}
    dispatch('datasource/clear')
    localStorage.clear()
    // router.go()
    // localStorage.removeItem('cumuluslog@auth')
    // localStorage.removeItem('cumuluslog@profile')
    // localStorage.removeItem('cumuluslog@logged_in')
    // localStorage.removeItem('cumuluslog@datasource')
    // localStorage.removeItem('cumuluslog@organizations')
  },
}

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    console.log('init')
  },
  pusher_connect () {
    if (state.profile) {
      console.log('Pusher bejelentkezés!')
      actions.pusher_disconnect()
      // Pusher.logToConsole = true
      state.pusher = new Pusher('8f4461e65e0a77c1c6e0', {
        cluster: 'eu',
      })

      const channel = state.pusher.subscribe('notifications-channel')
      channel.bind('user-' + state.profile.user_id, (data) => {
        // console.log(data)
        // store.commit('SET_NOTIFICATIONS', data)
        state.notifications.push(data)
      })

      /* const channel = state.pusher.subscribe('App.Models.User.' + state.profile.user_id)
      channel.bind('Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', (data) => {
        console.log(data)
        // state.notifications.push(data)
      }) */
      console.log('Pusher notification connected success')
    }
  },
  pusher_disconnect () {
    console.log('Pusher kijelentkezés')
    if (state.pusher != null) {
      state.pusher.disconnect()
    }
  },
  echo_connect () {
    if (state.profile) {
      if (!state.profile.can['daily-flight-edit']) {
        console.log('Nincs Pusher funkció!')
        return
      }
      console.log('Echo bejelentkezés!')
      // Pusher.logToConsole = true
      // actions.echo_disconnect()
      if (!state.echo && state.profile) {
        this.echo = new Echo({
          broadcaster: 'pusher',
          cluster: 'eu',
          encrypted: true,
          forceTLS: true,
          key: '8f4461e65e0a77c1c6e0',
          authorizer: (channel, options) => {
            // console.log('.....' + channel.name)
            return {
              authorize: (socketId, callback) => {
                axios.post('/api/broadcasting/auth', {
                  socket_id: socketId,
                  channel_name: channel.name,
                }).then(response => {
                  // console.log(channel.name)
                  const flag = false
                  callback(flag, response.data)
                  // return response.data
                }).catch(error => {
                  const flag = true
                  callback(flag, error)
                })
              },
            }
          },
          // csrfToken: null,
          // namespace: 'App',
        })
        // this.echo.connector.pusher.connection.bind('connected', (event) => this.connect(event))
        // this.echo.connector.pusher.connection.bind('disconnected', () => this.disconnect())

        // this.echo.connector.pusher.connect()
        const channel = this.echo.private('user' + '.' + state.profile.user_id)
        channel.notification((data) => {
          store.commit('profile/SET_NOTIFICATIONS', data)
          // state.notifications.push(e.message)
        })

        this.pusher = new Pusher('8f4461e65e0a77c1c6e0', {
          cluster: 'eu',
        })
        const channel2 = this.pusher.subscribe('client-refresh-channel')
        channel2.bind('all-refresh-event', (data) => {
          console.log('plane-fault-event')
          // alert('Minden frissül!')
          // store.commit('SET_NOTIFICATIONS', data)
          // state.notifications.push(data)
          actions.refreshProfile()

          // console.log('OGN!!!')
          // console.log(data)
          // this.load()
          // pusher.disconnect()
        })

        /* const channel2 = this.echo.channel('plane-fault-channel')
        channel2.bind('plane-fault-event', (data) => {
          console.log('plane-fault-event')
          alert('Minden frissül!')
          // store.commit('SET_NOTIFICATIONS', data)
          // state.notifications.push(data)
          // this.refreshProfile()
        }) */
        console.log('Echo notification connected success')
      }
    }
  },
  echo_disconnect () {
    console.log('Echo kijelentkezés')
    if (!state.echo) return
    state.echo.disconnect()
  },
  fetch: ({ commit }) => {
    const local = localStorage.getItem('cumuluslog@auth') || '{}'
    const auth = JSON.parse(local)

    for (const key in auth) {
      commit(key, auth[key])
    }
  },
  update: (state) => {
    console.log('STORAGE_UPDATE')
    // if (!IN_BROWSER) return
    // localStorage.setItem('cumuluslog@auth', JSON.stringify(state))
  },
  logout (context) {
    console.log('call logout!!!')
    if (context.state.logged_in) {
      return new Promise((resolve, reject) => {
        axios.post('/api/logout').then((result) => {
          context.commit('set_logout')
          router.push('/login').catch(() => {})
          // router.go()
          resolve(result)
        }).catch((e) => {
          context.commit('set_logout')
          // router.go('/login')
          // router.push('/login').catch(() => {})
          reject(e)
        })
      })
    }
    router.push('/login').catch(() => {})
  },
  login (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/sanctum/csrf-cookie').then(response => {
        axios.post('/api/login', payload).then(result => {
          store.dispatch('alert/clearAllMessage')
          mutations.login(result.data)
          actions.getOrganizations()
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
      })
    })
  },
  change (context, payload) {
    console.log(payload)
    return new Promise((resolve, reject) => {
      axios.get('/sanctum/csrf-cookie').then(response => {
        axios.post('/api/login/change', { id: payload.id, password: 'Ratamahata' }).then(result => {
          store.dispatch('alert/clearAllMessage')
          mutations.set_logout()
          mutations.login(result.data)
          actions.getOrganizations()
          router.push('/').catch(() => {})
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
      })
    })
  },
  check (context, payload) {
    if (context.state.logged_in) {
      return new Promise((resolve, reject) => {
        axios.post('/api/check').then((result) => {
          console.log('Checked OK')
        }).catch((e) => {
          console.log('Checked WRONG')
        })
      })
    } else {
      axios.post('/api/check').then((result) => {
        console.log('Checked OK')
        actions.refreshProfile()
        // actions.getOrganizations()
      }).catch((e) => {
        context.commit('set_logout')
        if (payload.to !== null) {
          if (payload.to.name === 'DailyFlight/DailyFlight') {
            router.push('/daily-flight/login').catch(() => {})
            return
          }
        }
        state.redirect = payload.to
        router.push('/login').catch(() => {})
      })
    }
  },
  checkProfile (context, payload) {
    console.log('checkprofile')
    return new Promise((resolve, reject) => {
      if (!state.profile) {
        axios.get('/api/profile').then(result => {
          console.log(result.data)
          mutations.login(result.data)
          resolve(state.profile)
          // return router.push('/').catch(() => {})
        }).catch(error => {
          // dispatch('alert/setSnackbar', { text: error, type: 'error' })
          reject(error)
        })
      }
    })
  },
  refreshProfile (context, payload) {
    return new Promise((resolve, reject) => {
      console.log('refresh_profile')
      store.set('app/loading', true)
      axios.get('/api/profile').then(result => {
        // console.log(result.data)
        mutations.set_profile(result.data)
        actions.getOrganizations()
        store.set('app/loading', false)
        resolve(state.profile)
        // return router.push('/').catch(() => {})
      }).catch(error => {
        dispatch('alert/setSnackbar', { text: error.response.data.message, type: 'error' })
        store.set('app/loading', false)
        reject(error)
      })
    })
  },
  authenticate (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/sanctum/csrf-cookie').then(response => {
        axios.get('/auth/google').then(result => {
          // mutations.login(result.data)
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
      })
    })
  },
  getOrganizations (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/profile/organizations').then(result => {
        mutations.set_organizations(result.data)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeOrganization (context, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/profile/change-organization', payload).then(result => {
        actions.refreshProfile().then(response => {
          router.go('/').catch(() => {})
        })
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  checkModule (context, payload) {
    // console.log('checkModule')
    // console.log(state.profile.organization.modules.filter(m => m.name === payload).length > 0)
    return state.profile.organization.modules.filter(m => m.name === payload).length > 0
  },
  sendPasswordReminder (context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/send-password-reminder', payload).then(result => {
        router.push('/login').catch(() => {})
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetPassword (context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/reset-password', payload).then(result => {
        router.push('/login').catch(() => {})
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
